<template>
  <div class="service_select">
    <div v-for="option in sortedOptions" :key="option.id" @click="toggleItem(option)"
      class="service_select--item"
      :class="{'service_select--selected': isServiceSelected(option),
      'error-border': validationRules && !validationRules.selectedServices.required && validationRules.selectedServices.$error}">
      <div class="service_item">
        <div class="service_item--info">
          <div class="service_item--name">
            {{ option | optionTranslate }}
          </div>

          <div v-if="displayPrices" class="service_item--price">
            {{option.priceGross | currency}}
          </div>
        </div>

        <div class="service_item--description" v-if="option.description">
          {{option.description}}
        </div>
      </div>
    </div>

    <div class="error-message" v-if="validationRules && !validationRules.selectedServices.required && validationRules.selectedServices.$error">
      {{$t('errors.required')}}
    </div>
  </div>
</template>
<script>
import { find, findIndex, sortBy } from 'lodash';

import { simpleServiceSortBy } from '@/util/smp_config';

export default {
  name: 'ServiceSelectionInput',
  props: {
    validationRules: Object,
    options: {
      default: () => [],
      type: Array,
      required: 'required'
    },
    value: {
      required: 'required'
    },
    multiple: {
      default: false
    },
    displayPrices: {
      default: false
    }
  },
  data() {
    return {
      selectedItems: this.value || []
    };
  },
  methods: {
    toggleItem: function(option) {
      if (this.multiple) {
        let toggleIndex = findIndex(this.selectedItems, { id: option.id });
        if (toggleIndex < 0) {
          this.selectedItems.push(option);
        } else {
          this.selectedItems.splice(toggleIndex, 1);
        }
      } else {
        this.selectedItems = [option];
      }
      this.triggerChange();
    },
    triggerChange: function () {
      this.$emit('input', this.selectedItems);
      this.$emit('change', this.selectedItems);
    },
    isServiceSelected: function (option) {
      return find(this.selectedItems, { id: option.id });
    }
  },
  computed: {
    sortedOptions() {
      if (simpleServiceSortBy === 'price') {
        return sortBy(this.options, (option) => option.priceGross?.value).reverse();
      }

      return sortBy(this.options, (option) => this.$options.filters['optionTranslate'](option));
    }
  }
}
</script>
